<template>
    <div class="search">
        <MetaBox :meta="{
            key: 'search',
            type: 'text',
            name: 'جست و جو'
        }" :vm="value" @onchange="(obj) => value = obj.value"></MetaBox>
    </div>
    <div class="finder">
        <template v-for="(entity, index) in entities" :key="index">
            <div class="flex wrap center vcenter" @click.prevent="$emit('onresult', entity.uid)">
                <div class="profile">
                    <img v-lazy="'/images/profile.webp'" alt="نمایه کاربری" loading="lazy" />
                </div>
                <div class="information">
                    <h1>نام و نام خانوادگی: {{ entity.name }}</h1>
                    <p v-if="entity.username">کدملی: {{ entity.username }}</p>
                </div>
            </div>
        </template>
        <div v-if="empty" class="empty flex wrap center vcenter">
            <div class="flex wrap center vcenter">
                <img v-lazy="'/images/search.gif'" alt="جست و جو" loading="lazy">
            </div>
            <h4>مورد جست و جو یافت نشد!</h4>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

export default {
    name: 'Finder',
    props: ['data'],
    inject: ['base'],
    components: {
        MetaBox: defineAsyncComponent(() => import('../Form/Inputs/MetaBox.vue'))
    },
    data() {
        return {
            value: '',
            entities: [],
            empty: false,
            timer: null
        }
    },
    watch: {
        value() {
            this.entities = []
            this.empty = false
            if (this.base.Util().validate(this.value)
                && this.value.length >= 10) {
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    this.base.API().get(`Identities/Account/Finder?query=${String(this.value).trim()}`,
                        (response) => {
                            if (this.base.Util().success(response))
                                if (this.base.Util().validate(response.data.data)) {
                                    this.entities = response.data.data
                                    return
                                }
                            this.empty = true
                        })
                }, 750)
            }
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/finder.css"></style>
<style scoped src="../../assets/css/components/dialogs/finder_dark.css"></style>